const translations = {
  "en": {
    "File too large (image ≤ %{var0} / file ≤ %{var1})": "File too large (image ≤ %{var0} / file ≤ %{var1})",
    "Format not supported. %{var0}": "Format not supported. %{var0}",
    "Some of your files could not be uploaded because you can only upload %{var0} attachments at a time": "Some of your files could not be uploaded because you can only upload %{var0} attachments at a time"
  },
  "zh-tw": {
    "File too large (image ≤ %{var0} / file ≤ %{var1})": "檔案過大（圖片 ≤ %{var0} / 檔案 ≤ %{var1}）",
    "Format not supported. %{var0}": "格式不受支援。%{var0}",
    "Some of your files could not be uploaded because you can only upload %{var0} attachments at a time": "由於你每次只能上傳 %{var0} 個附件，因此部分檔案無法上傳。"
  }
};

export default translations;
